import React from 'react';

import Button from '../../../components/ui/Button';
import Icon from '../../../components/ui/AppIcon';

export default function PressureHysteresisForm({ formState, formActions }) {
  const {
    setpoint,
    resolution,
    k,
    readings,
    readingsDecreasing,
  } = formState;

  const {
    setSetpoint,
    setResolution,
    setK,
    addReading,
    removeReading,
    updateReading,
    addReadingDecreasing,
    removeReadingDecreasing,
    updateReadingDecreasing,
  } = formActions;

  const syncReadingFields = () => {
    const targetLength = Math.max(readings.length, readingsDecreasing.length);
    formActions.setReadings((prev) => [...prev, ...Array(targetLength - prev.length).fill('')]);
    formActions.setReadingsDecreasing((prev) => [...prev, ...Array(targetLength - prev.length).fill('')]);
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <div>
          <label className="text-sm font-medium text-muted-foreground">Setpoint</label>
          <input
            type="number"
            className="w-full border rounded px-3 py-2"
            value={setpoint}
            onChange={(e) => setSetpoint(e.target.value)}
            placeholder="Valor objetivo"
          />
        </div>
        <div>
          <label className="text-sm font-medium text-muted-foreground">Resolución</label>
          <input type="number" className="w-full border rounded px-3 py-2" value={resolution} onChange={(e) => setResolution(e.target.value)} />
        </div>
        <div>
          <label className="text-sm font-medium text-muted-foreground">k (cobertura)</label>
          <input type="number" className="w-full border rounded px-3 py-2" value={k} onChange={(e) => setK(e.target.value)} />
        </div>
      </div>

      <div className="mb-2 flex justify-between items-center">
        <label className="text-sm font-medium">Lecturas del Punto</label>
        <Button size="sm" variant="outline" onClick={syncReadingFields}>
          <Icon name="Plus" size={14} className="mr-1" /> Agregar Fila
        </Button>
      </div>

      <div className="grid grid-cols-2 gap-x-6">
        <div>
          <h4 className="font-semibold text-center mb-2">Creciente</h4>
          {readings.map((val, i) => (
            <div key={`inc-${i}`} className="flex items-center gap-2 mb-2">
              <span className="w-16 text-sm text-muted-foreground">Lectura {i + 1}</span>
              <input
                type="number"
                className="flex-1 border rounded px-3 py-2"
                value={val}
                onChange={(e) => updateReading(i, e.target.value)}
              />
            </div>
          ))}
        </div>

        <div>
          <h4 className="font-semibold text-center mb-2">Decreciente</h4>
          {readingsDecreasing.map((val, i) => (
            <div key={`dec-${i}`} className="flex items-center gap-2 mb-2">
              <input
                type="number"
                className="flex-1 border rounded px-3 py-2"
                value={val}
                onChange={(e) => updateReadingDecreasing(i, e.target.value)}
              />
              <button
                type="button"
                onClick={() => {
                  removeReading(i);
                  removeReadingDecreasing(i);
                }}
                className="text-muted-foreground hover:text-foreground px-2"
                disabled={readings.length <= 1}
              >
                <Icon name="X" size={16} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
